import * as monaco from 'monaco-editor'

// Setup Monaco Editor worker
self.MonacoEnvironment = {
  getWorker: (_workerId, label) => {
    const getWorkerModule = (moduleUrl: string) => {
      self.MonacoEnvironment = {
        getWorker: () => new Worker(new URL(moduleUrl, import.meta.url)),
      }
      return new Worker(new URL(moduleUrl, import.meta.url))
    }

    switch (label) {
      case 'json':
        return getWorkerModule('monaco-editor/esm/vs/language/json/json.worker')
      case 'css':
      case 'scss':
      case 'less':
        return getWorkerModule('monaco-editor/esm/vs/language/css/css.worker')
      case 'html':
      case 'handlebars':
      case 'razor':
        return getWorkerModule('monaco-editor/esm/vs/language/html/html.worker')
      case 'typescript':
      case 'javascript':
        return getWorkerModule('monaco-editor/esm/vs/language/typescript/ts.worker')
      default:
        return getWorkerModule('monaco-editor/esm/vs/editor/editor.worker')
    }
  },
}

export default monaco
